import React from 'react';

import { IconTypes } from '@eika/icon';
import { Link } from '@eika/link';
import { Modal } from '@eika/modal';
import { RichIcon, RichIconTypes } from '@eika/rich-icon';

import { useConfig } from '../../../default-config';
import { useTranslation } from '../../../translations';

import './SdoHelpModal.scss';

interface SdoHelpModalProps {
    showModal: boolean;
    setShowModal: React.Dispatch<React.SetStateAction<boolean>>;
}
const SdoHelpModal = ({ showModal, setShowModal }: SdoHelpModalProps) => {
    const { sdoHelp } = useTranslation();
    const { sdoLink } = useConfig();
    return (
        <Modal contentClassName="sdo-help-modal" open={showModal} setOpen={setShowModal}>
            <RichIcon className="sdo-help-modal__icon" maxHeight={100} type={RichIconTypes.STANDARISERING_DIPLOM} />
            <h3>{sdoHelp.howOpen}</h3>
            <p>{sdoHelp.modalBody}</p>
            <Link className="sdo-help-modal__link" iconOnRightSide icon={IconTypes.EKSTERN_24} href={sdoLink.url}>
                {sdoHelp.linkText}
            </Link>
        </Modal>
    );
};

export default SdoHelpModal;
